import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/ldlCholesterol";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	ldlCholesterol: {
		id: "ktx.ldlCholesterol.title",
		defaultMessage: "LDL Koleszterin"
	},
	value: {
		id: "ktx.ldlCholesterol.field.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_ldlCholesterol",
	value: {
		schemaId: "ldlCholesterol",
		title: messages.ldlCholesterol,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
